// Components/ExportModal.js
import React, {useState} from 'react';
import {Download, X} from 'lucide-react';
import DateRangePicker from './DateRangePicker';

const ExportModal = ({isOpen, onClose, onExport, schoolId}) => {
    const [exportData, setExportData] = useState({
        school_id: schoolId || '',
        start_date: null,
        end_date: null,
        format: 'json'
    });

    const handleExport = () => {
        onExport(exportData);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
                <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                        <Download size={20} className="text-orange-600"/>
                        Export Audit Logs
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none"
                    >
                        <X size={20}/>
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    {/* School Selection */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            School
                        </label>
                        <select
                            value={exportData.school_id}
                            onChange={(e) => setExportData({...exportData, school_id: e.target.value})}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        >
                            <option value="">All Schools</option>
                            {/* You would populate this with actual school data */}
                            <option value="school1">School 1</option>
                            <option value="school2">School 2</option>
                            <option value="school3">School 3</option>
                        </select>
                        <p className="text-xs text-gray-500 mt-1">
                            Leave blank to export logs from all schools
                        </p>
                    </div>

                    {/* Date Range */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Date Range
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-lg">
                            <DateRangePicker
                                startDate={exportData.start_date}
                                endDate={exportData.end_date}
                                onChange={(startDate, endDate) => setExportData({
                                    ...exportData,
                                    start_date: startDate,
                                    end_date: endDate
                                })}
                                placeholder="Select date range for export"
                                className="flex-1 p-3"
                            />
                        </div>
                        <p className="text-xs text-gray-500 mt-1">
                            Leave blank to use default range (last 30 days)
                        </p>
                    </div>

                    {/* Export Format */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Export Format
                        </label>
                        <div className="flex space-x-4">
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="format"
                                    value="json"
                                    checked={exportData.format === 'json'}
                                    onChange={() => setExportData({...exportData, format: 'json'})}
                                    className="mr-2 text-orange-500 focus:ring-orange-500"
                                />
                                <span className="text-sm text-gray-700">JSON</span>
                            </label>
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="format"
                                    value="csv"
                                    checked={exportData.format === 'csv'}
                                    onChange={() => setExportData({...exportData, format: 'csv'})}
                                    className="mr-2 text-orange-500 focus:ring-orange-500"
                                />
                                <span className="text-sm text-gray-700">CSV</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="p-6 border-t border-gray-200 flex justify-end space-x-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleExport}
                        className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2"
                    >
                        <Download size={16}/>
                        Export
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal;